export class SvgResource
{
    public static readonly SVG_001 =
    "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFk" +
    "b2JlIElsbHVzdHJhdG9yIDE0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246" +
    "IDYuMDAgQnVpbGQgNDMzNjMpICAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFRE" +
    "IFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3Zn" +
    "MTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSLjg6zjgqTjg6Tjg7xfMSIgeG1sbnM9Imh0" +
    "dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcv" +
    "MTk5OS94bGluayIgeD0iMHB4IgoJIHk9IjBweCIgd2lkdGg9IjIwNi45M3B4IiBoZWlnaHQ9IjIw" +
    "Ni45M3B4IiB2aWV3Qm94PSIwIDAgMjA2LjkzIDIwNi45MyIgZW5hYmxlLWJhY2tncm91bmQ9Im5l" +
    "dyAwIDAgMjA2LjkzIDIwNi45MyIKCSB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHBhdGggZmlsbD0i" +
    "IzA0MDAwMCIgZD0iTTEwMy4wNiw0My41YzguMTUtMjYuMTksMjguNDItMzguNzksNTEuMTUtMzgu" +
    "NzljMjcuMTgsMCw0Ny45NCwyMi43NCw0Ny45NCw1MC4xNgoJYzAsMzMuMTEtMTguMDQsNTcuNTct" +
    "MzYuNTcsODAuMDZjLTE3Ljc5LDIxLjUtNTMuMzcsNTkuMDctNjIuNTIsNjguMmgtMC41Yy05LjE0" + 
    "LTkuMTMtNDQuNDgtNDYuNy02Mi4yNy02OC4yCglDMjEuNzYsMTEyLjQ1LDMuNzIsODcuOTgsMy43" +
    "Miw1NC44N2MwLTI3LjkzLDIxLjUtNTAuMTYsNDguMTgtNTAuMTZjMjIuNSwwLDQyLjUsMTIuNiw1" +
    "MC42NiwzOC43OUgxMDMuMDZ6Ii8+Cjwvc3ZnPgo=";

    public static readonly SVG_011 =
    "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFk" +
    "b2JlIElsbHVzdHJhdG9yIDE0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246" +
    "IDYuMDAgQnVpbGQgNDMzNjMpICAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFRE" +
    "IFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3Zn" +
    "MTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSLjg6zjgqTjg6Tjg7xfMSIgeG1sbnM9Imh0" +
    "dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcv" +
    "MTk5OS94bGluayIgeD0iMHB4IgoJIHk9IjBweCIgd2lkdGg9IjIwNi45M3B4IiBoZWlnaHQ9IjIw" +
    "Ni45M3B4IiB2aWV3Qm94PSIwIDAgMjA2LjkzIDIwNi45MyIgZW5hYmxlLWJhY2tncm91bmQ9Im5l" +
    "dyAwIDAgMjA2LjkzIDIwNi45MyIKCSB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBm" +
    "aWxsPSIjMDQwMDAwIiBkPSJNMTMyLjgzLDczLjE4bDY5LjMzLDguMjV2MC44NmwtNTAuNjQsNDcu" +
    "ODRsMTMuNzEsNjguNzdsLTAuNjQsMC4yMWwtNjEuNS0zNS4zN2wtNjEuNzYsMzUuMzdsLTAuNjQt" +
    "MC4yMQoJCWwxMy43Ni02OC43NUwzLjc0LDgyLjI4di0wLjg2bDY5LjExLTguNzRsMjkuNjgtNjMu" +
    "NDJoMC44NkwxMzIuODMsNzMuMTh6Ii8+CjwvZz4KPC9zdmc+Cgo=";

    public static readonly SVG_020 =
    "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFk" +
    "b2JlIElsbHVzdHJhdG9yIDE0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246" +
    "IDYuMDAgQnVpbGQgNDMzNjMpICAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFRE" +
    "IFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3Zn" +
    "MTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSLjg6zjgqTjg6Tjg7xfMSIgeG1sbnM9Imh0" +
    "dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcv" +
    "MTk5OS94bGluayIgeD0iMHB4IgoJIHk9IjBweCIgd2lkdGg9IjIwNi45M3B4IiBoZWlnaHQ9IjIw" +
    "Ni45M3B4IiB2aWV3Qm94PSIwIDAgMjA2LjkzIDIwNi45MyIgZW5hYmxlLWJhY2tncm91bmQ9Im5l" +
    "dyAwIDAgMjA2LjkzIDIwNi45MyIKCSB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHBhdGggZmlsbD0i" +
    "IzA0MDAwMCIgZD0iTTE0OS43MSwxNTYuMjljMTkuMzUsMTUuNzIsNzEuNTctMjYuODUsMzAuNzMt" +
    "NTUuN2MyMS44NS0yNy43Ny0xMS4zOC03MC4wNC00MC4wMi01My4xMwoJYy05LjI1LTI2LjU4LTQx" +
    "LjA5LTM0LjI0LTU2LjgxLTcuODZDNjAuODYsMjEuMDYsMzIuNTIsMzQuNDcsMjcuODMsNjIuM2Mt" +
    "MzQuNTktMS4zMy00Mi44OCw1Ni41OC05LjE3LDY5LjU0CgljLTIuMzcsMjkuNjEsMzMuNDQsNDQu" +
    "MzQsNTEuNjQsMzIuODJjNS4xMSwzMC40MSw0NS4xNywzMC41NCw1Ny42Nyw1Ljg0YzIzLjU1LDE2" +
    "LjAzLDI3LjUxLDE3LjA2LDUxLjk3LDE1LjQ4CglDMTYxLDE3OC43NiwxNTYuMTYsMTcwLjgsMTQ5" +
    "LjcxLDE1Ni4yOXoiLz4KPC9zdmc+Cg==";
}